<template>
  <div class="domains-browse">
    <div
      class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom"
    >
      <h1 class="h2">Domains</h1>
      <span v-if="total >= 0" class="text-muted">{{
        total | pluralize("domain")
      }}</span>
    </div>

    <div class="form-row mb-3">
      <div class="col-md-6 mb-2">
        <input
          class="form-control"
          type="text"
          placeholder="Search by domain…"
          v-model="filters.q"
          v-on:input="onSearchInput"
        />
      </div>
      <div class="col-md-3 mb-2">
        <select
          class="form-control"
          v-model="filters.state"
          v-on:change="applyFilters"
        >
          <option value="">Any status</option>
          <option value="actives">Active</option>
          <option value="inactives">Inactive</option>
        </select>
      </div>
    </div>

    <template v-if="loading">
      <div class="alert alert-info" role="alert">Loading…</div>
    </template>
    <template v-else-if="total > 0">
      <div class="table-responsive">
        <table class="table table-striped table-hover">
          <thead>
            <tr>
              <td>Domain</td>
              <td>Account</td>
              <td>Aliases</td>
              <td>Added</td>
              <td class="text-center">Active?</td>
            </tr>
          </thead>
          <tbody>
            <tr v-for="domain in items" v-bind:key="domain.domain">
              <td>
                <router-link
                  :to="{
                    name: 'domain-details',
                    params: { domain: domain.domain },
                  }"
                >
                  {{ domain.domain }}
                </router-link>
                <span v-if="domain.banned" class="ml-2 badge badge-danger"
                  >banned</span
                >
              </td>
              <td>
                <router-link
                  v-if="domain.account"
                  :to="{
                    name: 'account-details',
                    params: { email: domain.account.email },
                  }"
                >
                  {{ domain.account.email }}
                </router-link>
              </td>
              <td>{{ domain.aliases }}</td>
              <td>{{ domain.added | datetime }}</td>
              <td class="text-center">
                <i
                  v-if="domain.active"
                  class="icon ion-md-checkmark-circle"
                  title="Active"
                ></i>
                <i v-else class="icon ion-md-close-circle-outline"></i>
              </td>
            </tr>
          </tbody>
          <tfoot>
            <tr>
              <td colspan="3">
                <a
                  v-if="page > 0"
                  href="javascript:;"
                  title="View previous page"
                  v-on:click="previousPage"
                  class="btn btn-primary btn-sm"
                  >Previous</a
                >
              </td>
              <td colspan="2" class="text-right">
                <a
                  v-if="(page + 1) * limit < total"
                  href="javascript:;"
                  title="View next page"
                  v-on:click="nextPage"
                  class="btn btn-primary btn-sm"
                  >Next</a
                >
              </td>
            </tr>
          </tfoot>
        </table>
      </div>
    </template>
    <template v-else>
      <div class="alert alert-warning" role="alert">
        No domains match these filters.
      </div>
    </template>
  </div>
</template>

<script>
import { formatHttpError } from "../../utils/errors";

export default {
  data() {
    return {
      total: -1,
      items: [],
      page: 0,
      limit: 25,
      loading: false,
      searchTimeout: null,
      filters: {
        q: "",
        state: "",
      },
    };
  },
  created() {
    this.fetch();
  },
  beforeDestroy() {
    if (this.searchTimeout) {
      clearTimeout(this.searchTimeout);
    }
  },
  methods: {
    fetch() {
      this.loading = true;
      this.$http
        .post("domains", {
          q: this.filters.q,
          state: this.filters.state,
          offset: this.page,
          limit: this.limit,
        })
        .then(
          (response) => {
            this.total = response.body.total;
            this.items = response.body.items;
            this.limit = response.body.limit;
            this.loading = false;
          },
          (response) => {
            this.loading = false;
            if (response.status === 401) return;
            alert(formatHttpError(response));
          },
        );
    },
    applyFilters() {
      this.page = 0;
      this.fetch();
    },
    onSearchInput() {
      if (this.searchTimeout) {
        clearTimeout(this.searchTimeout);
      }
      this.searchTimeout = setTimeout(this.applyFilters, 300);
    },
    nextPage() {
      this.page += 1;
      this.fetch();
    },
    previousPage() {
      this.page -= 1;
      if (this.page < 0) {
        this.page = 0;
      }
      this.fetch();
    },
  },
};
</script>
